module.exports = __webpack_public_path__ + "static/d06-cf1e50d8b1d5803b772eab3e8b858707.png";